import Base from 'app/views/base';
import BankAccountButtonView from 'app/components/pages/billing/payment_methods/bank_account_button';
import CreditCardButtonView from 'app/components/pages/billing/payment_methods/credit_card_button';

import tmpl from './type_selection_template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {},

  initialize({ priority, user }) {
    this.priority = priority;
    this.addSubview(
      'creditCardButton', '.credit_card_button',
      new CreditCardButtonView({ model: this.model, priority: this.priority, user }),
    );
    this.addSubview(
      'bankAccountButton', '.bank_account_button',
      new BankAccountButtonView({ model: this.model, priority: this.priority }),
    );
  },

  context() {
    return {
      isPrimary: this.priority === 'primary',
    };
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/billing/payment_methods/type_selection_view.js